export default {"src":"/_next/static/media/sad-dizzy.5509c0b9.svg","height":40,"width":40};